import React, { useEffect, useState } from "react";
import Wrapper from "../components/wrapper";
import {
  Layout,
  Typography,
  Table,
  Space,
  Button,
  DatePicker,
  Tooltip,
} from "antd";

import { useDispatch, useSelector } from "react-redux";
import { fetchProvinceMonitoring } from "../redux/actions/adminDashBoard";

import { Link } from "react-router-dom/cjs/react-router-dom";

const { RangePicker } = DatePicker;
const { Title } = Typography;
const { Content: LayoutContent } = Layout;

const ProvinceMonitoring = () => {
  const dispatch = useDispatch();

  const { loading, data } = useSelector(({ AdminDashBoardReducer }) => ({
    loading: AdminDashBoardReducer.loading,
    data: AdminDashBoardReducer.provinceMonitoring,
  }));

  const [timeRange, setTimeRange] = useState(null);

  const handleTimeChange = (value) => {
    setTimeRange(value);
  };

  useEffect(() => {
    if (timeRange) {
      const startDate = timeRange[0].format("YYYY-MM-DD");
      const endDate = timeRange[1].format("YYYY-MM-DD");

      dispatch(
        fetchProvinceMonitoring({
          defaultDate: false,
          fromDate: startDate,
          toDate: endDate,
        })
      );
    } else {
      dispatch(fetchProvinceMonitoring({ defaultDate: true }));
    }
  }, [dispatch, timeRange]);

  const columns = [
    {
      title: "Province",
      dataIndex: "province",
      key: "province",
      sorter: (a, b) => a.province.localeCompare(b.province),
    },
    {
      title: (
        <Tooltip title="Percentage of cities in this province with Riders who topped up and opened the Rider app">
          Rider %
        </Tooltip>
      ),
      dataIndex: "rider_percentage",
      key: "rider_percentage",
      sorter: (a, b) =>
        parseFloat(a.rider_percentage) - parseFloat(b.rider_percentage),
    },
    {
      title: (
        <Tooltip title="Percentage of municipalities with integrated merchants">
          Merchant %
        </Tooltip>
      ),
      dataIndex: "merchant_percentage",
      key: "merchant_percentage",
      sorter: (a, b) =>
        parseFloat(a.merchant_percentage) - parseFloat(b.merchant_percentage),
    },
    {
      title: (
        <Tooltip title="Total number of customers in this province">
          # of users
        </Tooltip>
      ),
      dataIndex: "customer_count",
      key: "customer_count",
      sorter: (a, b) => a.customer_count - b.customer_count,
    },
    {
      title: (
        <Tooltip title="Total Cancel Order in this province">
          Total Cancel
        </Tooltip>
      ),
      dataIndex: "totalCancelCount",
      key: "totalCancelCount",
      sorter: (a, b) => a.totalCancelCount - b.totalCancelCount,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Link to={`/${record.province}/city-monitoring`}>
            <Button type="primary" size="small">
              Details
            </Button>
          </Link>
        </Space>
      ),
    },
  ];

  const renderContent = () => {
    return (
      <LayoutContent>
        <div>
          <Title level={2}>Area Monitoring</Title>
        </div>
        <div style={{ marginBottom: "10px", fontSize: "14px", color: "#888" }}>
          <Tooltip title="This filter only applies to Rider % column, to adjust the rider percentage based on the selected time range.">
            <span>Filter only affects Rider %.</span>
          </Tooltip>
        </div>
        <div>
          <RangePicker value={timeRange} onChange={handleTimeChange} />
          <Table
            columns={columns}
            dataSource={data}
            bordered
            loading={loading}
          />
        </div>
      </LayoutContent>
    );
  };

  return (
    <>
      <Wrapper content={renderContent()} />
    </>
  );
};

export default ProvinceMonitoring;
